import React from 'react';
import { DataTypeProvider } from '@devexpress/dx-react-grid';
import { isValueBiggerThanColumnWidth } from '@/helpers/utils';
import TooltipComponent from '@/components/UI/Tooltip/TooltipComponent';
import styles from '../SearchTable.module.scss';

interface TableTooltipProps {
  columns: { name: string; title: string }[];
  columnExtensions: { columnName: string; width: number }[];
}

const TableTooltip: React.FC<TableTooltipProps> = (props) => {
  const { columns, columnExtensions } = props;

  const TooltipFormatter = (elementProps: DataTypeProvider.ValueFormatterProps) => (isValueBiggerThanColumnWidth(elementProps, columnExtensions)
    ? <TooltipComponent title={elementProps?.value}><span className={styles.SpanTooltip}>{elementProps?.value}</span></TooltipComponent>
    : <span>{elementProps?.value}</span>
  );

  return (
    <DataTypeProvider
      for={columns.map(({ name }) => name)}
      formatterComponent={TooltipFormatter}
      {...props}
    />
  );
};

export default TableTooltip;
